import PATIENT_ONLINE_FRAGMENT from '../../graphql/patient/fragments/PatientOnline.gql'
import PROVIDER_ONLINE_FRAGMENT from '../../graphql/provider/fragments/ProviderOnline.gql'

export const getOnlinePresence = (client, identifier, id) => {
  const queryProps = /patient/.test(identifier)
    ? {
        fragment: PATIENT_ONLINE_FRAGMENT,
        fragmentName: 'PatientOnline',
        id: `Patient:${id}`,
      }
    : {
        fragment: PROVIDER_ONLINE_FRAGMENT,
        fragmentName: 'ProviderOnline',
        id: `Provider:${id}`,
      }
  const data = client.readFragment(queryProps)
  return { data, queryProps }
}

export const userPresenceUpdated = (client: any, event: any): void => {
  if (event?.data?.id) {
    const isOnline = event.event === 'online'
    const { data, queryProps } = getOnlinePresence(
      client,
      event.channel,
      event.data.id,
    )
    if (data?.isOnline !== isOnline) {
      client.writeFragment({
        data: { ...data, isOnline },
        ...queryProps,
      })
    }
  }
}
